/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./AddLead.module.css";
import Close from "../../Components/Icons/Close";
import { uploadLeadToContactGroup } from "../../Services/SmartFloApis";

import { useNavigate, useParams } from "react-router-dom";
//*subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import TimeComponent from "../../Subcomponents/TimeComponent";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";

import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import RightArrow from "../../Components/Icons/RightArrow";
// import SearchIcon from "../Icons/SearchIcon";

import MobileStepper from "@mui/material/MobileStepper";
import {
  Autocomplete,
  createTheme,
  Divider,
  Paper,
  TextField,
  ThemeProvider,
} from "@mui/material";

//*images
import backArrow from "../../Assets/Images/Common/backArrow.svg";
import AddIcon from "../../Assets/Images/Common/addSitePrefernces.svg";

//
import Countdown, { zeroPad } from "react-countdown";
import debounce from "lodash.debounce";

//*services
import {
  getPAN_cardDetails,
  getAadharCardDetails,
} from "../../Services/SurepassApi";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";

import {
  getNationality,
  getNative,
  getProfessions,
  getProjectUnitType,
  // checkPersonExists,
  checkPhoneNumberIsBlackListed,
  addPersonTable,
  addLeadsTable,
  addLeadStatus,
  addKYCDoc,
  getProjects,
  addProjectPrefernces,
  checkPhoneNumberExists,
  checkForUniqueDocs,
  addLeadLogs,
  getProjectsForLeads,
  getNativeByName,
  getUsers,
  getUsersForTeamLead,
  checkLeadEmailExists,
  checkLeadEmailExistsInUsers,
  checkLeadEmailExistsInCp,
  getAssignedProjectsForLeadPreference,
  sendWhatsappMessageOnLeadRegisteredDirect,
  getCUID,
  getProjectsData,
  getCustomerDetails,
  addLead,
  getProjectsDataPre,
  getPersonFromAllotmentPayment,
  getLeadData,
  getLeadPersonData,
  getAllUnitsByProjectIdWingsId,
  getAllWingsByProjectIdPre,
  addLeadsReferralTable,
  checkLeadContactExists,
} from "../../Services/Lead";
import { getAllUser, getAllUserByName } from "../../Services/LoginService";
import { sendOTPMessage, sendMailTo, sendOTPMessageForLeadRegistration } from "../../Services/SmsService";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";

//*react-phone-number-input
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { Fragment } from "react";
import {
  getInventoryTypeFromProjectName,
  getProjectByProjectName,
} from "../../Services/SustenanceService";
import { getFormatedEmail } from "../../Services/Settings";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";
import { Network } from "@capacitor/network";
import { sortBy, uniq, uniqBy } from "lodash";
import axios from "axios";
// import { handleErrors } from "../../Services/LoginService";
const useStyles = makeStyles((theme) => ({
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));
const AutoCompleTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          padding: "0.5rem 1.4rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
            borderBottom: "1px solid #878383 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },
          "&.Mui-focused": {
            background: "#FFFFFF !important",
            border: "1px solid #84CAFF !important",

            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF !important",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
export default function AddLead({
  open,
  handleClose,
  leadAddedResp,
  modalType,
}) {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  const [personalDetail, setPersonalDetail] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    gender: "Male",
    typeOfLead: "Direct",
    disabledName: false,
    disabledPhoneNumber: false,
    disabledGender: false,
    leadSubType: "",
    leadReferrerName: "",
  });
  const [generalDetail, setGeneralDetail] = useState({
    nationality: "",
    native: "",
    worksIn: "",
    disabledNationality: false,
    disabledNative: false,
    disabledWorksIn: false,
  });
  const [projectFieldArray, setProjectFieldArray] = useState([
    {
      selectedProject: "",
      flatUnitType: "",
      SitePrefernces: null,
      availableUnitType: [],
      isPrimary: true,
      alreadyAdded: false,
      selectedProjectData: null
    },
  ]);
  const helperTextObj = {
    selectedProject: "",
    flatUnitType: "",
    SitePrefernces: "",
  };
  const [projectFieldHelperText, setProjectFieldHelperText] = useState([
    helperTextObj,
  ]);

  const { projectName } = useParams();
  const [isEmailValid, setIsEmailValid] = useState(false)
  const [projectNameList, setProjectNameList] = useState([]);
  const [projectUnitArray, setProjectUnitArray] = useState([]);
  const [panNumber, setPanNumber] = useState("");
  const [panName, setPanName] = useState("");
  const [panObject, setPanObject] = useState(null);
  const [helperText, setHelperText] = useState({
    name: "",
    email: "",
    isPhoneNumber: "",
    panNumber: "",
    isPanValid: false,
    nationality: "",
    native: "",
    worksIn: "",
    referal: "",
  });
  const [totalSteps, setTotalStep] = useState(6);
  const [activeStep, setActiveStep] = React.useState(1);
  const [personalButtonNext, setPersonalButtonNext] = useState(false);
  const [generalButtonNext, setGeneralButtonNext] = useState(false);
  const [projectButtonNext, setProjectButtonNext] = useState(false);
  const [isCPLead, setIsCPLead] = useState(false);
  console.log("isCPLead ==========> ", isCPLead);
  const [showOtp, setShowOtp] = useState(false);
  const [showOtpEmail, setShowOtpEmail] = useState(false);
  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [stateEmail, setStateEmail] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [isInterNational, setIsInterNational] = useState(false);
  const [recievedOtp, setRecievedOtp] = useState(null);
  const [recievedOtpEmail, setRecievedOtpEmail] = useState(null);
  const [otptimer, setOtpTimer] = useState(false);
  const [otptimerEmail, setOtpTimerEmail] = useState(false);
  const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [wroksIn, setWorksIn] = useState([]);
  const [native, setNative] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const [InventoryType, setInventoryType] = useState([]);
  const navigate = useNavigate();
  const classes = useStyles();
  const [personExist, setPersonExists] = useState(false);
  const [personId, setPersonId] = useState("");
  const [allUser, setAllUser] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [resendButtonEmail, setResendButtonEmail] = useState(false);
  const startDate = React.useRef(Date.now());
  // **New changes from trello card 601
  const [referrerDetails, setReferrerDetails] = useState({
    type: "",
    name: "",
    contactNumber: "",
    projectName: "",
    projectId: "",
    wingName: "",
    wingId: "",
    unitNo: "",
    unitId:"",
    remarks: "",
    relationship: "",
    rnl_customer_id: "",
    rnl_rm_id: 0,
    rnl_rm_display_name: "",
  });
  const [referrerDetailsHelperText, setReferrerDetailsHelperText] = useState({
    type: "",
    name: "",
    contactNumber: "",
    projectName: "",
    projectId: "",
    wingName: "",
    wingId: "",
    unitNo: "",
    remarks: "",
    relationship: ""
  });
  const [allWings, setAllWings] = useState([]);
  const [emailLabelText, setEmailLabelText] = useState("");

  const [projectsList, setProjectsList] = useState([]);
  const [projectsListPre, setProjectsListPre] = useState([]);
  const [wingsList, setWingsList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [unitsListPre, setUnitsListPre] = useState([]);
  const [leadIdPre,setLeadIdpre]= useState([]);
  const [leadIdPost,setLeadIdPost]= useState(null);
  const [assignedCallerNo, setAssignedCallerNo] = useState("");
  useEffect(() => {
    // console.log(loggedInUser?.userId);
    // getAllUser(null).then((resp) => {
    //   console.log(resp);
    //   setAllUser(resp);
    if (modalType === "SustenanceAddLead") {
      getProjectData();
    }
    // });
  }, []);
  useEffect(() => {
    if (
      referrerDetails.relationship === "Self" &&
      (
        referrerDetails.type?.includes("Pre-Agreement") ||
        referrerDetails.type?.includes("Post-Agreement")
      )

    ) {
       //console.log("Autofilling personal details with referrer", referrerDetails);
      setPersonalDetail((prev) => ({
        ...prev,
        name: referrerDetails.name || prev.name || "",
        email: referrerDetails.email || "",
        phoneNumber: referrerDetails.contactNumber || prev.phoneNumber || "",
        disabledName: true,
        disabledPhoneNumber: true,
        disabledEmail: true,
      }));
      console.log("Referral Detail Email", referrerDetails.email)
    } else {
      setPersonalDetail((prev) => ({
        ...prev,
        disabledName: false,
        disabledPhoneNumber: false,
        disabledEmail: false
      }));
    }
  }, [referrerDetails]);

   useEffect(() => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem("user"));
    console.log("User from localStorage:-------------------", userFromLocalStorage);
    if (userFromLocalStorage) {
      setAssignedCallerNo(userFromLocalStorage?.assignedCallerDid || "");
    }
  }, []);

  // **Change for referal dropdown
  const getSalesPersonDetails = useRef(
    debounce((e) => {
      // console.log(e);
      if (e !== "") {
        getAllUserByName(e)
          .then((resp) => {
            // console.log(resp);
            if (resp.length !== 0) {
              setAllUser(resp);
            } else {
              // helperText.salesPersonName = "";
              setAllUser([]);
              setPersonalDetail((pre) => {
                pre.leadReferrerName = "";
                pre.leadSubType = "";
                return { ...pre };
              });
              // setHelperText((pre) => {
              //   pre.salesPersonName = "";
              //   return { ...pre };
              // });
            }
          })
          .catch((err) => {
            errorTost(err.message);
            setAllUser([]);
            setPersonalDetail((pre) => {
              pre.leadReferrerName = "";
              pre.leadSubType = "";
              return { ...pre };
            });
          });
      } else {
        setAllUser([]);
        setPersonalDetail((pre) => {
          pre.leadReferrerName = "";
          pre.leadSubType = "";
          return { ...pre };
        });
      }
    }, 800)
  ).current;
  useEffect(() => {
    // if (activeStep === 3) {
    // if (window.navigator.onLine) {
    if (modalType !== "SustenanceAddLead") {
      Network.getStatus().then((status) => {
        if (status.connected) {
          // getProjects()
          if (loggedInUser.roleId.level !== 1) {
            getAssignedProjectsForLeadPreference(loggedInUser?.userId)
              .then((assignedProjectRes) => {
                assignedProjectRes = assignedProjectRes.filter((el) => el.projectId !== null);
                assignedProjectRes = assignedProjectRes.map((el) => ({ ...el, projectId: el?.projectId?.projectId, projectName: el?.projectId?.projectName, projectData: el?.projectId }))
                // console.log({ assignedProjectRes });
                setProjectNameList(assignedProjectRes);
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            getProjectsForLeads()
              .then((resp) => {
                // console.log(resp);
                setProjectNameList(resp);
              })
              .catch((err) => {
                console.error(err);
              });
          }
        } else {
          offlineToast();
        }
      });
    }
    // } else {
    // offlineToast();
    // }
    // }
  }, [activeStep]);
  useEffect(() => {
    if (activeStep === 2) {
      Network.getStatus().then((status) => {
        if (status.connected) {
          getNationality()
            .then((resp) => {
              setNationality(resp);
            })
            .catch((err) => {
              errorTost(err.message);
              // handleErrors(err, "add lead - get nationality");
            });
          getNative()
            .then((resp) => {
              setNative(resp);
            })
            .catch((err) => {
              errorTost(err.message);
            });
          getProfessions()
            .then((resp) => {
              // console.log(resp);
              setWorksIn(resp);
            })
            .catch((err) => {
              errorTost(err.message);

              // handleErrors(err, "add lead - get professions");
            });
        } else {
          offlineToast();
        }
      });
    }
  }, [activeStep]);
  useEffect(() => {
    let validation = validatePersonalDetailsForButton();
    if (validation.flag) {
      setPersonalButtonNext(true);
    } else {
      setPersonalButtonNext(false);
    }
  }, [personalButtonNext, validatePersonalDetailsForButton]);

  useEffect(() => {
    let validation = validateGeneralDetailsForButton();
    if (validation.flag) {
      setGeneralButtonNext(true);
    } else {
      setGeneralButtonNext(false);
    }
  }, [generalButtonNext, validateGeneralDetailsForButton]);
  useEffect(() => {
    let validation = validateProjectFieldsForButton();
    if (validation.flag) {
      setProjectButtonNext(true);
    } else {
      setProjectButtonNext(false);
    }
  }, [projectButtonNext, validateProjectFieldsForButton]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (activeStep === 3) {
      // console.log("done");
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 1) {
      handleClose();
    }
  };
  const PAN_CardCheck = useRef(
    debounce((e, _apiToken) => {
      // if (window.navigator.onLine) {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan(false);
          // console.log(res.data);
          if (res?.data?.message_code === "success") {
            checkForUniqueDocs(e)
              .then((resp) => {
                // console.log(resp);
                if (resp.length) {
                  setHelperText((pre) => {
                    pre.panNumber = "User already exists";
                    pre.isPanValid = false;
                    return { ...pre };
                  });
                  setPanName("");
                  setPanObject("");
                } else {
                  // console.log(
                  //   "res.data.data.full_name",
                  //   res.data.data.full_name
                  // );
                  setPanName(
                    res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
                  );
                  setPanObject(res.data.data);
                  if (
                    res.data.data.full_name
                      .toUpperCase()
                      .replace(/\s\s+/g, " ") !== personalDetail.name
                  ) {
                    setOpenConfirmation(true);
                  }
                  setHelperText((pre) => {
                    pre.panNumber = "";
                    return { ...pre };
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
            setHelperText((pre) => {
              pre.isPanValid = true;
              return { ...pre };
            });
          } else {
            setIsLoadingPan(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPan(false);
          // console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanName("");
            let pre = { ...helperText };
            pre.panNumber = err?.response?.data?.message;
            pre.isPanValid = false;

            setHelperText({ ...pre });
          }
          errorTost(err.message);

          // handleErrors(err, "add lead - pan card");
        });
      // } else {
      //   offlineToast();
      // }
    }, 800)
  ).current;

  const getAllNatives = useRef(
    debounce((e) => {
      // console.log(e);
      if (e !== "") {
        getNativeByName(e)
          .then((resp) => {
            // console.log(resp);
            if (resp.length !== 0) {
              setNative(resp);

              setHelperText((pre) => {
                pre.native = "";
                return { ...pre };
              });
            } else {
              helperText.native = "";
              setNative([]);
              setGeneralDetail((pre) => {
                pre.native = "";
                return { ...pre };
              });
              setHelperText((pre) => {
                pre.native = "";
                return { ...pre };
              });
            }
          })
          .catch((err) => {
            errorTost(err.message);
            setAllUser([]);
            setPersonalDetail((pre) => {
              pre.leadReferrerName = "";
              pre.leadSubType = "";
              return { ...pre };
            });
          });
      } else {
        setAllUser([]);
        setPersonalDetail((pre) => {
          pre.leadReferrerName = "";
          pre.leadSubType = "";
          return { ...pre };
        });
      }
    }, 800)
  ).current;
  function getProjectData() {
    getProjectByProjectName(projectName)
      .then((resp1) => {
        if (resp1.data) {
          // console.log("ProjectData", resp1.data[0].projectId);
          getInventoryTypeFromProjectName(resp1.data[0].projectId)
            .then((resp2) => {
              // console.log("InventoryType", resp2.data);
              setInventoryType(resp2.data);
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }
  function getAllWings(project) {
    setWingsList(project.wings);
    // getWingsByProjectId(projectId)
    //   .then((resp) => {
    //     console.log("allWings", resp);
    //     setAllWings([...resp.data]);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }
  function validationPersonalDetails() {
    var form = true;
    if (personalDetail.name === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.name = "Please Enter Name";
        return { ...preValue };
      });
    }
    if (personalDetail.email === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.email = "Please Enter Email Id";
        return { ...preValue };
      });
    }

    if (personalDetail.phoneNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPhoneNumber = "Please Enter Phone Number";
        return { ...preValue };
      });
    } else {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
    }
console.log("referrerDetails.type --------------->", referrerDetails.type)
      // if (personalDetail.typeOfLead === "Direct") {
      //   if (
      //     !personalDetail.leadReferrerName ||
      //     personalDetail.leadSubType === ""
      //   ) {
      //     form = false;
      //     setHelperText((preValue) => ({
      //       ...preValue,
      //       referal: "Please select Referral Name",
      //     }));
      //   }
      // }
     if (personalDetail.typeOfLead === "R&L") {
       if (referrerDetails.type === "") {
        form = false;
        setReferrerDetailsHelperText((preValue) => {
          preValue.type = "Please select Reference From";
          return { ...preValue };
        });
      }
      if(referrerDetails.type==="Existing customer - Pre-Agreement"){
        if (referrerDetails.projectId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.projectId = "Please Select project Name";
            return { ...preValue };
          });
        }
        if (referrerDetails.wingId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.wingId = "Please Select wing Name";
            return { ...preValue };
          });
        }
        if (referrerDetails.unitId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.unitId = "Please Select unit No";
            return { ...preValue };
          });

          unitsListPre.length===0 &&  setReferrerDetailsHelperText((preValue) => {
            preValue.unitId = "No unit available";
            return { ...preValue };
          });
        }
        if (referrerDetails.relationship === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.relationship = "Please Select relationship";
            return { ...preValue };
          });
        }
        
      }
      
    }

    if (personalDetail.typeOfLead === "R&L") {
      if(referrerDetails.type==="Existing Customer - Post-Agreement"){
        console.log("POST AGRREEMENT VALIDATION CALLED===========");
        console.log("referrerDetails =========>", referrerDetails);
        if (referrerDetails.projectId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.projectId = "Please Select project Name";
            return { ...preValue };
          });
        }
        if (referrerDetails.wingId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.wingId = "Please Select wing Name";
            return { ...preValue };
          });
        }
        if (referrerDetails.unitId === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.unitId = "Please Select unit No";
            return { ...preValue };
          });

          unitsListPre.length===0 &&  setReferrerDetailsHelperText((preValue) => {
            preValue.unitId = "No unit available";
            return { ...preValue };
          });
        }
        if (referrerDetails.relationship === "") {
          form = false;
          setReferrerDetailsHelperText((preValue) => {
            preValue.relationship = "Please Select relationship";
            return { ...preValue };
          });
        }
        
      }
      
    }


 if(referrerDetailsHelperText.contactNumber !== ""){
  form = false;
 }
    return {
      flag: form,
    };
  }
  function validatePersonalDetails() {
    let flag = validationPersonalDetails();
    if (
      flag.flag &&
      helperText.name === "" &&
      helperText.email === "" &&
      helperText.isPhoneNumber === "" &&
      referrerDetailsHelperText.type === "" &&
      verifiedPhoneNumber
    ) {
      handleNext();
    }
  }

  function validatePersonalDetailsForButton() {
    var form = true;
    if (helperText.name !== "" || personalDetail.name === "") {
      form = false;
    }
    if (helperText.email !== "" || personalDetail.email === "") {
      form = false;
    }
    if (helperText.isPhoneNumber !== "" || personalDetail.phoneNumber === "") {
      form = false;
    }
    // if (personalDetail.typeOfLead === "Direct") {
    //   if (helperText.referal !== "" || personalDetail.leadReferrerName === "") {
    //     form = false;
    //   }
    // }
    if (referrerDetailsHelperText.contactNumber !== "") {
      form = false;
    }
    if (verifiedPhoneNumber === false) {
      form = false;
    }
    return {
      flag: form,
    };
  }

  function validationGeneralDetails() {
    var form = true;
    if (generalDetail.nationality === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.nationality = "Please Select Nationality";
        return { ...preValue };
      });
    }
    if (generalDetail.native === "" || generalDetail.native === null) {
      form = false;
      setHelperText((preValue) => {
        preValue.native = "Please Select Native";
        return { ...preValue };
      });
    }

    if (generalDetail.worksIn === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.worksIn = "Please Select worksIn";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validateGeneralDetails() {
    let flag = validationGeneralDetails();
    if (
      flag.flag &&
      helperText.nationality === "" &&
      helperText.native === "" &&
      helperText.worksIn === ""
    ) {
      handleNext();
    }
  }

  function validateGeneralDetailsForButton() {
    var form = true;
    if (helperText.nationality !== "" || generalDetail.nationality === "") {
      form = false;
    }
    if (helperText.native !== "" || generalDetail.native === "") {
      form = false;
    }
    if (helperText.worksIn !== "" || generalDetail.worksIn === "") {
      form = false;
    }
    return {
      flag: form,
    };
  }

  function validationProjectFields() {
    var form = true;
    projectFieldArray.forEach((el, index) => {
      if (modalType === "SustenanceAddLead") {
        el.selectedProject = projectName;
      } else if (el.selectedProject === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].selectedProject = "Please Select Project First";
          return [...pre];
        });
      }
      if (el.flatUnitType === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].flatUnitType = "Please Select Flat/Unit Type";
          return [...pre];
        });
      }

      // if (el.SitePrefernces === "") {
      //   form = false;
      //   setProjectFieldHelperText((pre) => {
      //     pre[index].SitePrefernces = "Please Select Date";
      //     return [...pre];
      //   });
      // }
    });

    return {
      flag: form,
    };
  }

  function validateProjectFields() {
    // console.log(projectFieldArray);
    let flag = validationProjectFields();
    if (flag.flag) {
      handleNext();
    }
  }
  function validateProjectFieldsForButton() {
    var form = true;
    projectFieldArray.forEach((el, index) => {
      if (el.selectedProject === "") {
        form = false;
      }
      if (el.flatUnitType === "") {
        form = false;
      }

      // if (el.SitePrefernces === "") {
      //   form = false;
      // }
    });
    return {
      flag: form,
    };
  }

  function optChange(value1, event) {
    // console.log(value1, event);
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  function optChangeEmail(value1, event) {
    // console.log(value1, event);
    event.preventDefault();
    setStateEmail((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  async function submit() {
    if (window.navigator.onLine) {
      if (personExist === false && helperText.panNumber === "") {
        Network.getStatus().then((status) => {
          if (status.connected) {
            presentLoader();
            addPersonTable(personalDetail, generalDetail)
              .then(async (personRes) => {
                // console.log({ loggedInUser });
                let teamLeadRes = null;
                // !!Find Project Prefernce primary and set userId to projectHead
                let preferncedProjectArr = projectFieldArray.filter(({ isPrimary }) => isPrimary === true);
                // console.log({ preferncedProjectArr })

                // !!Finding Team Lead for dashboard purpose
                // !!Commmented this  due to changes come on 18/4/23

                // if (
                //   (loggedInUser?.isTeamLead === false ||
                //     loggedInUser?.isTeamLead === null) &&
                //   loggedInUser?.parentId !== null
                // ) {
                //   teamLeadRes = await findTeamLead(loggedInUser?.parentId?.userId);
                //   console.log({ teamLeadRes });
                // } else if(loggedInUser?.isTeamLead) {
                //   teamLeadRes = loggedInUser?.userId;
                // }else{
                //   // !!SuperAdmin
                //   teamLeadRes=null;
                // }
                // console.log({ teamLeadRes });
                await addLeadsTable(
                  personRes[0].personId,
                  loggedInUser.userId,
                  personalDetail.typeOfLead,
                  personalDetail,
                  referrerDetails,
                  loggedInUser?.parentId?.userId,
                  preferncedProjectArr[0]?.selectedProjectData?.userId
                )
                   .then(async (result) => {
                    const leadId = result[0]?.leadId;

                    // ✅ ADD YOUR NEW API HERE
                    console.log("Assigned Caller No: ", assignedCallerNo);
                    if (assignedCallerNo) {
                      uploadLeadToContactGroup(leadId)
                        .then(() => console.log("Lead uploaded to contact group"))
                        .catch((err) => console.error("Contact group upload failed", err));
                    }
                    presentLoader()
                    axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}users/createLeadLoginAuth`, { leadId: result[0]?.leadId, contactNumber: personalDetail?.phoneNumber }).then((val) => {
                     
                    }).catch(err => {
                      dismissLoader()
                      errorTost(err.message)
                    })

                    addLeadStatus(result[0].leadId)
                      .then(async (leadRes) => {
                        let obj = {
                          userId: loggedInUser.userId,
                          leadId: result[0].leadId,
                          leadStatus: leadRes[0].status,
                          message: `Lead created by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                        };
                        addLeadLogs(obj)
                          .then((leadLog) => {
                            // console.log(leadLog);
                          })
                          .catch((err) => {
                            // console.log("leadlog", err);
                          });
                        projectFieldArray.forEach((el) => {
                          addProjectPrefernces(el, personRes[0].personId)
                            .then((project) => {
                              // console.log("projectPrefernce", project);
                            })
                            .catch((err) => {
                              dismissLoader();
                              // handleErrors(err, "add lead - project pref");
                              errorTost(err.message);
                            });
                        });

                        if (panNumber !== "") {
                          addKYCDoc(
                            result[0].leadId,
                            panNumber.toUpperCase(),
                            panName.toUpperCase().replace(/\s\s+/g, " "),
                            panObject,
                            "PanCard"
                          )
                            .then((res) => {
                              // dismissLoader();
                              // console.log(res);
                            })
                            .catch((err) => {
                              dismissLoader();
                              // handleErrors(err, "add lead - kyc doc");
                              errorTost(err.message);
                            });
                        }
                        getFormatedEmail("Lead Onboarding")
                          .then((resp) => {
                            // console.log(resp.data[0].emailTemplate);
                            let message = resp.data[0].emailTemplate.replace(
                              "{{leadName}}",
                              `${personalDetail.name.toUpperCase()}`
                            );
                            sendMail(
                              personalDetail.email,
                              resp.data[0].emailSubject,
                              message
                            );
                            // **message
                            // let messageBody = {
                            //   number: "+" + personalDetail?.phoneNumber,
                            //   message: `You have registered with VjSales Successfully.Keep in touch for further details.`,
                            //   is_international_number:
                            //   personalDetail?.phoneNumber.toString().substring(0, 2) !== "91"
                            //       ? true
                            //       : false,
                            // };
                            //  sendMessage(messageBody)
                            //   .then((resp) => {
                            //     if (resp.data.success) {
                            //       return true;
                            //     } else {
                            //       if (resp?.data?.error) {
                            //         return false;
                            //       }
                            //     }
                            //   })
                            //   .catch((err) => {
                            //     console.log(err.message);
                            //     return false;
                            //   });
                          })
                          .catch((err) => {
                            console.error(err);
                          });
                        let whatsappToast = "";
                        getCUID(result[0].leadId).then(async (res) => {
                           
                          const payload = {
                            referralName: personalDetail.name,//add name changes
                            email: personalDetail.email,
                            mobileNo: personalDetail.phoneNumber,
                            userId: referrerDetails.rnl_customer_id, //rnl customer id
                            unitId: referrerDetails.unitId,  // rnl unit id added
                            referredBy: referrerDetails.name,
                            projectName: preferncedProjectArr[0].selectedProject,
                            apartmentPreference: preferncedProjectArr[0].flatUnitType,
                            locationPreference: "Baner",
                            budget: "70 Lakhs to 1 Crore",
                            sales_app_lead_id: result[0].leadId,
                            leadRelationship: referrerDetails.relationship,
                            sales_app_lead_display_id: res?.[0]?.leadDisplayId,
                            smId: loggedInUser.userId,//claimedIdBy  from leads table
                            smName: loggedInUser.name,
                            rmId: referrerDetails.rnl_rm_id//name from user table
                          }
                          await addLead(payload).then((respLead) => {
                            console.log("respLead", respLead);
                          }).catch((err) => {
                            console.error("Whatsapp error", err);
                          })
                          //Send whatsapp message
                          await sendWhatsappMessageOnLeadRegisteredDirect(personalDetail?.phoneNumber,
                            personalDetail?.name,
                            // res?.[0]?.leadDisplayId
                            'VJ' + res?.[0]?.leadDisplayId.replace(res?.[0]?.leadDisplayId.substring(8, 12), '-' + res?.[0]?.leadDisplayId.substring(8, 12))
                          ).then((res) => {
                            // console.log("Whatsapp response", res);
                            whatsappToast = "Whatsapp message sent successfully."
                          }).catch((err) => {
                          
                            whatsappToast = "Error while sending whatsapp message."
                          })
                        }).catch((err) => {
                          console.error(err);
                        })
                        // console.log("whatsappToast", whatsappToast)
                        dismissLoader();
                        successTost("Lead added successfully " + whatsappToast);
                        leadAddedResp(true);
                        closeModal();
                      })
                      .catch((err) => {
                        dismissLoader();
                        errorTost(err.message);
                      });
                   
                      const payloadReffal = {
                        leadReferrerName: referrerDetails.name,
                        unitNo:referrerDetails.unitNo,
                        wing:referrerDetails.wingName,
                        project:referrerDetails.projectName,
                        leadId:result[0]?.leadId,
                        relationshipManager: referrerDetails?.rnl_rm_display_name || "",
                        custId: referrerDetails?.rnl_customer_id || 0,
                        referralDetails:{"leadRelationship": referrerDetails.relationship,
                        "remark": referrerDetails.remarks,
                        "leadReferrerMobile": referrerDetails.contactNumber},
                        subType: referrerDetails.relationship?.toLowerCase() == "self" ? "Loyalty" : "Reference",
                        referrerLeadId:leadIdPre
                      }
                      // console.log("payloadReffal============>", payloadReffal);
                      referrerDetails.type==="Existing customer - Pre-Agreement" &&  addLeadsReferralTable(payloadReffal).then((respLeadReffal) => {
                      
                      }).catch((err) => {
                        console.error("addLeadsReferralTable error", err);
                      })
           const payloadRefferPost = {
                        leadReferrerName: referrerDetails.name,
                        unitNo:referrerDetails.unitNo,
                        wing:referrerDetails.wingName,
                        project:referrerDetails.projectName,
                        leadId:result[0]?.leadId,
                        relationshipManager: referrerDetails?.rnl_rm_display_name || "",
                        custId: referrerDetails?.rnl_customer_id || 0,
                        referralDetails:{"leadRelationship": referrerDetails.relationship,
                        "remark": referrerDetails.remarks,
                        "leadReferrerMobile": referrerDetails.contactNumber},
                        subType: referrerDetails.relationship?.toLowerCase() == "self" ? "Loyalty" : "Reference",
                        referrerLeadId:leadIdPost
                      }
                      // console.log("payloadRefferPost============>", payloadRefferPost);
                      referrerDetails.type === "Existing Customer - Post-Agreement" &&  addLeadsReferralTable(payloadRefferPost).then((respLeadPost) => {
                      
                      }).catch((err) => {
                        console.error("addLeadsReferralTable post error", err);
                      })
                  })
                  .catch((err) => {
                    dismissLoader();
                    // handleErrors(err, "add lead");
                    errorTost(err.message);
                  });
              })
              .catch((err) => {
                dismissLoader();
                // handleErrors(err, "add lead - add person");
                errorTost(err.message);
              });
          } else {
            offlineToast();
          }
        });
      }
    }
  }
  async function findTeamLead(userId) {
    return new Promise((resolve, reject) => {
      getUsersForTeamLead(userId).then((userRes) => {
        // console.log({ userRes });

        if (userRes[0].parentId !== null) {
          if (userRes[0].isTeamLead) {
            // console.log(userRes[0].isTeamLead);

            resolve(userRes[0].userId);
          } else if (!userRes[0].isTeamLead) {
            findTeamLead(userRes[0]?.parentId);
          } else {
            // console.log(null);
            resolve(null);
          }
        } else {
          // console.log(null);
          resolve(null);
        }
      });
    });
  }
  function closeModal() {
    setActiveStep(1);
    handleClose();
  }
  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    // console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      setVerifiedPhoneNumber(true);
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }

  function submitOtpEmail() {
    let finalValue = stateEmail.otp1 + stateEmail.otp2 + stateEmail.otp3 + stateEmail.otp4;
    // console.log(finalValue, "recievedOtp", recievedOtpEmail);
    if (finalValue == recievedOtpEmail) {
      setVerifiedEmail(true);
      setShowOtpEmail(false);
      setOtpTimerEmail(false);
      setHelperText((pre) => {
        pre.email = "";
        return { ...pre };
      });
    } else {
      setStateEmail((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }

  function smsTimeOut() {
    if (verifiedPhoneNumber === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setShowOtp(true);
      setVerifiedPhoneNumber(false);
      setOtpTimer(true);
      setResendButton(true);
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedOtp(null);
    }
  }
  // function smsApiCall() {
  //   setResendButton(false);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   setShowOtp(true);
  //   let body = {
  //     number: personalDetail.phoneNumber,
  //     isInterNational: isInterNational,
  //     email: personalDetail.email ?? null,
  //   };
  //   // console.log(body);
  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       if (resp.data.success) {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         setRecievedOtp(parseInt(originalText));
  //         // console.log("Add Lead OTP", parseInt(originalText));
  //         // 900000 ;15 min
  //         const myTimeout = setTimeout(smsTimeOut, 900000);
  //       } else {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         setRecievedOtp(parseInt(originalText));
  //         // console.log("Add Lead OTP", parseInt(originalText));
  //         if (resp?.data?.error?.ErrorMessage) {
  //           errorTost(resp?.data?.error?.ErrorMessage);
  //         } else {
  //           errorTost("Something went wrong");
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       // console.log(err.message);
  //     });
  // }
function smsApiCall() {
    setResendButton(false);
    setState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setShowOtp(true);
    let body = {
      number: personalDetail.phoneNumber,
      isInterNational: isInterNational,
      email: personalDetail.email ?? null,
    };
    // console.log(body);
    sendOTPMessage(body)
      .then((resp) => {
        // if (resp.data.success) {
        //   var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
        //   var originalText = bytes.toString(CryptoJS.enc.Utf8);
        //   setRecievedOtp(parseInt(originalText));
        //   console.log("Add Lead OTP", parseInt(originalText));
        //   // 900000 ;15 min
        //   const myTimeout = setTimeout(smsTimeOut, 900000);
        // } else {
        //   var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
        //   var originalText = bytes.toString(CryptoJS.enc.Utf8);
        //   setRecievedOtp(parseInt(originalText));
        //   console.log("Add Lead OTP", parseInt(originalText));
        //   if (resp?.data?.error?.ErrorMessage) {
        //     errorTost(resp?.data?.error?.ErrorMessage);
        //   } else {
        //     errorTost("Something went wrong");
        //   }
        // }

        if (resp.data) {
  // console.log("📦 Frontend received safeEncrypted:", resp.data.otp);
  		if (!isInterNational && !resp.data.success) {
  errorTost("SMS sending failed. Please try again.");
  return;
}

  
  // Step 1: Decode Base64
  const encryptedBase64 = resp.data.otp;
  const encrypted = atob(encryptedBase64);  
  // console.log("🔒 Frontend ciphertext after atob:", encrypted);

  // Step 2: Decrypt with same key
  var bytes = CryptoJS.AES.decrypt(encrypted, "hts secret key");
  var originalText = bytes.toString(CryptoJS.enc.Utf8);

  if (!originalText) {
    console.error("Decryption failed! Key or ciphertext mismatch.");
    errorTost("OTP decryption failed, please try again.");
    return;
  }

  // console.log("Add Lead OTP", parseInt(originalText));
  setRecievedOtp(parseInt(originalText));

  // 15 min timeout
  setTimeout(smsTimeOut, 900000);
} else {
  if (resp?.data?.error?.ErrorMessage) {
    errorTost(resp?.data?.error?.ErrorMessage);
  } else {
    errorTost("Something went wrong");
  }
}

      })
      .catch((err) => {
        console.error(err);
        // console.log(err.message);
      });
  }

  function emailApiCall() {
    setResendButtonEmail(false);
    // const myTimeout = setTimeout(() => {
    //   setResendButton(true);
    // }, 180000);
    setStateEmail((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setShowOtpEmail(true);
    let body = {
      email: personalDetail.email ?? null,
      leadName:personalDetail.name ?personalDetail.name:  "Sir / Madam",
    };
    // console.log(body);
    sendOTPMessageForLeadRegistration(body)
      .then((resp) => {
        if (resp.data.success) {
          var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
          var originalText = bytes.toString(CryptoJS.enc.Utf8);
          setRecievedOtpEmail(parseInt(originalText));
          // console.log("Add Lead OTP", parseInt(originalText));
          // 900000 ;15 min
          const myTimeout = setTimeout(smsTimeOut, 900000);
        } else {
          var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
          var originalText = bytes.toString(CryptoJS.enc.Utf8);
          setRecievedOtpEmail(parseInt(originalText));
          // console.log("Add Lead OTP", parseInt(originalText));
          if (resp?.data?.error?.ErrorMessage) {
            errorTost(resp?.data?.error?.ErrorMessage);
          } else {
            errorTost("Something went wrong");
          }
        }
      })
      .catch((err) => {
        // console.log(err);
        console.log(err.message);
      });
  }

 
  function sendMail(email, subject, message) {
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    sendMailTo(body)
      .then((resp) => {
        // console.log(resp);
        // console.log(resp.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // const checkEmailExists = useRef(debounce(async (e) => {
  //   console.log({e});
  //   let emailExists=null;
  //       // ??First checked in leads 
  //       await checkLeadEmailExists(e).then((emailCheckResp)=>{
  //       console.log({emailCheckResp});

  //       if(emailCheckResp.length>0){
  //         emailExists=true;
  //       console.log({emailExists});
  //       }else{
  //         console.log({emailExists});
  //         emailExists=false;
  //         setHelperText((pre)=>{
  //           pre.email='';
  //           return {...pre}
  //         });

  //       }
  //       }).catch((error)=>{
  //         console.log(error);
  //       });
  //       // ??Second Check in Users
  //       if(!emailExists){
  //         await   checkLeadEmailExistsInUsers(e).then((responseInUser)=>{
  //            if(responseInUser.length>0){
  //              emailExists=true;
  //              console.log({emailExists});
  //            }else{
  //              emailExists=false;
  //              console.log({emailExists});
  //            }
  //            }).catch((err)=>{
  //              console.log(err.message);
  //            });
  //       }
  //       // ??Third Check in Cp
  //       if(!emailExists){
  //    await   checkLeadEmailExistsInCp(e).then((cpRespEmail)=>{
  //     if(cpRespEmail.length>0){
  //       emailExists=true;
  //     }else{
  //       emailExists=false;
  //     }
  //     console.log({emailExists});

  //       });
  //     }
  //     if(emailExists){
  //       console.log({emailExists});
  //       setHelperText((pre)=>{
  //         pre.email='Email Already exists';
  //         return {...pre}
  //       });
  //     }else{
  //       setHelperText((pre)=>{
  //         pre.email='';
  //         return {...pre}
  //       });

  //     }
  // }, 900)).current;

  const checkEmailExists = debounce(async (e) => {
    setEmailLabelText("Send Otp");
    setIsEmailValid(true);
    helperText.email = "";
  }, 900);

  // const checkPersonExistsInTable = debounce((e) => {
  //   if (window.navigator.onLine) {
  //     checkPersonExists(e)
  //       .then((resp) => {
  //         if (resp.length) {
  //           setPersonId(resp[0].personId);
  //           setPersonalDetail((pre) => {
  //             pre.name = resp[0].name;
  //             pre.phoneNumber = "+91" + resp[0].contactNumber;
  //             pre.gender = resp[0].gender;
  //             pre.disabledName = true;
  //             pre.disabledPhoneNumber = true;
  //             pre.disabledGender = true;
  //             return { ...pre };
  //           });
  //           setGeneralDetail((pre) => {
  //             pre.nationality = resp[0].Nationality.nationalityId;
  //             pre.worksIn = resp[0].Professions.professionId;
  //             pre.native = resp[0].native;
  //             pre.disabledNationality = true;
  //             pre.disabledNative = true;
  //             pre.disabledWorksIn = true;
  //             return { ...pre };
  //           });

  //           let tempArray = projectFieldArray;
  //           tempArray = resp[0].ProjectPreference.map((el, index) => {
  //             return {
  //               selectedProject: el.projectName,
  //               flatUnitType: el.unitType,
  //               SitePrefernces: el.dateTime,
  //               isPrimary: el.isPrimary,
  //               alreadyAdded: true,
  //             };
  //           });
  //           setProjectFieldArray(tempArray);
  //           setProjectFieldHelperText(tempArray.map((_) => helperTextObj));
  //           setHelperText((pre) => {
  //             pre.email = "";
  //             pre.name = "";
  //             pre.nationality = "";
  //             pre.isPhoneNumber = "";
  //             pre.worksIn = "";
  //             pre.navtive = "";
  //             return { ...pre };
  //           });
  //           setPersonExists(true);
  //           console.log({ projectFieldArray });
  //         } else {
  //           setPersonId("");
  //           setPersonalDetail((pre) => {
  //             pre.name = "";
  //             pre.gender = "Male";
  //             pre.phoneNumber = "";
  //             pre.disabledName = false;
  //             pre.disabledPhoneNumber = false;
  //             pre.disabledGender = false;
  //             return { ...pre };
  //           });
  //           setGeneralDetail((pre) => {
  //             pre.nationality = "";
  //             pre.worksIn = "";
  //             pre.native = "";
  //             pre.disabledNationality = false;
  //             pre.disabledNative = false;
  //             pre.disabledWorksIn = false;
  //             return { ...pre };
  //           });
  //           setProjectFieldArray([
  //             {
  //               selectedProject: "",
  //               flatUnitType: "",
  //               SitePrefernces: "",
  //               isPrimary: false,
  //               alreadyAdded: false,
  //             },
  //           ]);
  //           setHelperText((pre) => {
  //             pre.email = "";
  //             pre.name = "";
  //             pre.nationality = "";
  //             pre.worksIn = "";
  //             pre.navtive = "";
  //             return { ...pre };
  //           });
  //           setPersonExists(false);
  //         }
  //       })
  //       .catch((err) => {
  //         handleErrors(err, "add lead - check person exists");
  //       });
  //   } else {
  //     offlineToast();
  //   }
  // }, 800);
  const IsNumberBlackListed = debounce((e) => {
    // console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        // console.log(resp);
        if (resp.length > 0) {
          //    setHelperText((pre) => {
          //   pre.isPhoneNumber = "";
          //   return { ...pre };
          // });

          setHelperText((pre) => {
            pre.isPhoneNumber = "This number is already in use!";
            return { ...pre };
          });
        } else {
          checkLeadContactExists(e)
            .then((contactRes) => {
              if (contactRes?.blocked) {
                setHelperText((pre) => {
                  pre.isPhoneNumber = contactRes.message;
                  return { ...pre };
                });
              } else {
                setHelperText((pre) => {
                  pre.isPhoneNumber = "";
                  return { ...pre };
                });
              }
            })
            .catch((err) => {
              console.log(err);
              setHelperText((pre) => {
                pre.isPhoneNumber = "";
                return { ...pre };
              });
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);
  function funGetProjectUnitType(projectId, index) {
    // if (window.navigator.onLine) {
    getProjectUnitType(projectId)
      .then((resp) => {
        // console.log(resp);
        resp = resp.map((el) => {
          if (el?.displaytype !== null && el?.displaytype !== '') {
            return el?.type + '(' + el?.displaytype + ')';
          } else {
            return el?.type;
          }
        });
        // console.log(resp);
        setProjectFieldArray((pre) => {
          pre[index].availableUnitType = resp;
          return [...pre];
        });
        setProjectUnitArray(resp);
      })
      .catch((err) => {
        // handleErrors(err, "add lead - get project unit type");
        errorTost(err.message);
      });
    // } else {
    //   offlineToast();
    // }
  }

  async function getProjectDetails() {
    await getProjectsData().then((resp) => {
      if (resp?.data?.data) {
        setProjectsList(resp.data.data)
      } else {
        errorTost("Error in fetching project details. Please try again later!")
      }
    }).catch((err) => {
      errorTost("Error in fetching project details. Please try again later!")
    })
  }

  async function getProjectDetailsPreExisting() {
    await getProjectsDataPre().then((resp) => {
      if (resp?.data) {
        setProjectsListPre(resp.data)
      } else {
        errorTost("Error in fetching project details. Please try again later!")
      }
    }).catch((err) => {
      errorTost("Error in fetching project details. Please try again later!")
    })
  }

  async function getWingsDetailsPreExisting(value) {
    await  getAllWingsByProjectIdPre(value)
    .then((res) => {
      const Data = uniqBy(res.data, 'wingId.wingId');
      const dataWing=Data.map((e)=>{
        return e.wingId
      })
      setAllWings(dataWing);
    })
    .catch((err) => {
      console.error('getAllWingsByProjectId', err);
    }); 
  }
  const getRerreralDetailsPre=async(value)=>{
   await getPersonFromAllotmentPayment(value)
    .then((response) => {
      const excludedStatuses = ["Released", "Cancelled", "Refund Initiated", "Refund Processed", "Agreement Done"];
      const leadIdData = response.data.find(ele => !excludedStatuses.includes(ele.status))?.leadId;
      if (!leadIdData) {
        console.error("Lead ID not found");
        return;
      }
      setLeadIdpre(leadIdData);
      return getLeadData(leadIdData);
    })
    .then((leadDataRes) => {
      console.log("leadDataRes==============>", leadDataRes);
      if(leadDataRes.data[0]?.leadType?.toLowerCase() === "cp"){
        
        console.log("CP LEAD BLOCK EXECUTED ==============");
        //throw error if lead type is CP
        // errorTost("this lead is a CP lead, please select another lead");
        setIsCPLead(true);
      }else{
        setIsCPLead(false);
      }

      const personID = leadDataRes.data[0]?.personId;
      if (!personID) {
        console.error("Person ID not found");
        return;
      }
      return getLeadPersonData(personID);
    })
    .then((prsonDataRes) => {
      setReferrerDetails((pre) => {
        pre.name =prsonDataRes.data[0]?.name;
        pre.contactNumber =prsonDataRes.data[0]?.contactNumber?.toString();                                ;
        return { ...pre };
      });

    })
    .catch((err) => {
      console.error('Error occurred during API calls', err);
    });
  }
  async function getCustomerData() {
    await getCustomerDetails(referrerDetails.projectName, referrerDetails.wingName, referrerDetails.unitNo).then((resp) => {
      if (resp?.data?.data) {
        setReferrerDetails((pre) => {
          pre.name = resp?.data?.data[0]?.name;
          pre.contactNumber = resp?.data?.data[0]?.mobile;
          pre.rnl_customer_id=resp?.data?.data[0]?.rnl_customer_id;
          pre.unitId=resp?.data?.data[0]?.rnl_fv_unit_id;
          pre.rnl_rm_display_name=resp?.data?.data[0]?.rnl_rm_display_name;
          pre.rnl_rm_id=resp?.data?.data[0]?.rnl_rm_id;  
          return { ...pre };
        });
      } else {
        errorTost("Error in fetching existing customer details. Please try again later!")
      }
    }).catch((err) => {
      errorTost("Error in fetching existing customer details. Please try again later!")
    })
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperHeader}>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </span>
            {/* <img className={cssClasses.block} src={block} alt="icon"></img> */}
            <div>Add Lead</div>
            {activeStep !== 1 && (
              <img
                className={cssClasses.backArrow}
                src={backArrow}
                onClick={handleBack}
                alt={"backArrow"}
                tabIndex="0"
              ></img>
            )}
          </div>

          <div className={cssClasses.wrapperStepper}>
            <MobileStepper
              variant="progress"
              steps={totalSteps}
              position="static"
              activeStep={activeStep}
              className={classes.stepper}
              sx={{
                maxWidth: "100%",
                // maxWidth:600,
                flexGrow: 1,
                margin: "0 auto",
                background: "#ffff ",
              }}
            />
          </div>

          <div className={cssClasses.label}>
            {totalSteps - activeStep - 1} Steps to add Lead
          </div>
          {activeStep === 1 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>General Details</div>
              <div className={cssClasses.addHeightToMiddleContent}>
                <div>
                  <CustomInput
                    style={{ textTransform: "uppercase" }}
                    value={personalDetail.name}
                    label={"Name"}
                    mandatory={true}
                    disabled={personalDetail.disabledName}
                    // handleChange={(newValue) => {
                    //   newValue = newValue.trimStart();
                    //   var alphabet = /^[A-Z*\sa-z]*$/;
                    //   if (newValue.match(alphabet) || newValue === "") {
                    //     if (newValue.length <= 40) {
                    //       setPersonalDetail((pre) => {
                    //         pre.name = newValue;
                    //         return { ...pre };
                    //       });
                    //     }
                    //   }
                    //   if (newValue !== "") {
                    //     setHelperText((pre) => {
                    //       pre.name = "";
                    //       return { ...pre };
                    //     });
                    //   } else {
                    //     helperText.name = "Please Enter Name";
                    //   }
                    // }}
                         handleChange={(newValue) => {
                      newValue = newValue.trimStart();
                      var alphabet = /^[A-Z*\sa-z]*$/;

                      if (newValue.match(alphabet) || newValue === "") {
                        if (newValue.length <= 40) {
                          setPersonalDetail((prev) => ({
                            ...prev,
                            name: newValue
                          }));
                        }
                      }

                      if (newValue !== "") {
                        setReferrerDetailsHelperText((prev) => ({
                          ...prev,
                          name: ""
                        }));
                      } else {
                        setReferrerDetailsHelperText((prev) => ({
                          ...prev,
                          name: "Please Enter Name"
                        }));
                      }
                    }}
                    placeholder="Enter Name"
                    inputType="label"
                    helperText={helperText.name}
                  />
                </div>
                <div style={{ position: "relative" }}>
                  <CustomInput
                    label={"Email Id"}
                    labelText={emailLabelText}
                    mandatory={true}
                    value={personalDetail.email}
                    handleChange={(newValue) => {
                      setEmailLabelText("");
                      newValue = newValue.trimStart();
                      // const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      const emailIDCond = /^(?!.*[\0-\x1F\x7F\/])(?=[^@]{1,64}@)[a-zA-Z0-9._%+-]+@(?:(?!.*?\.\.)[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
                      if (!newValue.trim()) {
                        setEmailLabelText("");
                        helperText.email = "Please Enter Email Id";
                        setIsEmailValid(false)
                      } else if (!newValue.match(emailIDCond)) {
                        setEmailLabelText("");
                        helperText.email =
                          "Please Enter Valid Email";
                        setIsEmailValid(false)
                      } else {
                        setEmailLabelText("");
                        helperText.email = "Verifying...";
                        // checkEmailExists(newValue);
                        if (newValue !== "") {
                          // console.log("Here")
                          checkEmailExists(newValue);
                        } else if (newValue === "") {
                          setEmailLabelText("");
                        }
                      }
                      if (newValue.length <= 50) {
                        setPersonalDetail((pre) => {
                          pre.email = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }}
                    placeholder="Enter contact person Email"
                    inputType="label"
                    helperText={helperText.email}
                    disabled={showOtpEmail || verifiedEmail || resendButtonEmail}
                  // greenTick={isEmailValid}
                  />

                  {helperText.email === "" &&
                    personalDetail.email !== "" &&
                    verifiedEmail === false &&
                    showOtpEmail === false &&
                    otptimerEmail === false &&
                    (
                      <div
                        className={cssClasses.verifyOtpEmail}
                        onClick={() => {
                          emailApiCall();
                        }}
                      >
                        Verify Otp
                      </div>
                    )}
                  {verifiedEmail === false &&
                    showOtpEmail === true &&
                    resendButtonEmail === true && (
                      <div
                        className={cssClasses.verifyOtpEmail}
                        onClick={() => {
                          setHelperText((pre) => {
                            pre.email = "";
                            return { ...pre };
                          });
                          emailApiCall();
                        }}
                      >
                        Resend Otp
                      </div>
                    )}
                  {verifiedEmail === false &&
                    showOtpEmail === true &&
                    resendButtonEmail === false && (
                      <div className={cssClasses.resendOtp}>
                        {" "}
                        Resend Otp in{" "}
                        {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
                        <CountdownTimer
                          startFrom={180}
                          onComplete={() => {
                            setResendButtonEmail(true);
                          }}
                          timeFormatter={(time) => {
                            return (
                              <span>
                                {`0${Math.floor(time / 60)}`.slice(-2)}:
                                {`0${time % 60}`.slice(-2)}
                              </span>
                            );
                          }}
                        />
                      </div>
                    )}
                  {helperText.email === "" &&
                    verifiedEmail &&
                    otptimerEmail === false && (
                      <div className={cssClasses.verifyOtpEmail}>
                        <CheckCircleSharpIcon
                          style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                          color={"success"}
                        />
                      </div>
                    )}
                  {showOtpEmail && (
                    <div className={cssClasses.otpContainer}>
                      <input
                        className={cssClasses.otpInput}
                        name="otp1"
                        id="opt-0"
                        type="text"
                        autoComplete="off"
                        value={stateEmail.otp1}
                        // onKeyPress={keyPressed}
                        onChange={(e) => optChangeEmail("otp1", e)}
                        tabIndex="0"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp2"
                        id="opt-1"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={stateEmail.otp2}
                        onChange={(e) => optChangeEmail("otp2", e)}
                        tabIndex="1"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp3"
                        id="opt-2"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={stateEmail.otp3}
                        onChange={(e) => optChangeEmail("otp3", e)}
                        tabIndex="2"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp4"
                        type="text"
                        id="opt-3"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={stateEmail.otp4}
                        onChange={(e) => optChangeEmail("otp4", e)}
                        tabIndex="3"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />

                      <div>
                        <Button
                          tabIndex={4}
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#155EEF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          btnName={"Submit OTP"}
                          clicked={submitOtpEmail}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ position: "relative" }}>
                  <div className={cssClasses.blockLabel}>
                    Phone Number <span style={{ color: "red" }}> *</span>
                  </div>
                  {/* <PhoneInput
                    defaultCountry="IN"
                    value={personalDetail.phoneNumber}
                    disabled={showOtp || verifiedPhoneNumber || resendButton}
                    placeholder="Enter phone number"
                    onChange={(phone) => {
                      // console.log(phone);
                      if (phone !== undefined) {
                        if (phone.length >= 1) {
                          if (isValidPhoneNumber(phone) === false) {
                            setVerifiedPhoneNumber(false);
                            helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                            setShowOtp(false);
                          } else {
                            helperText.isPhoneNumber = "";
                            setVerifiedPhoneNumber(false);

                            // console.log(phone.substring(4, 13));
                            if (phone.substring(0, 3) === "+91") {
                              if (phone.substring(4, 13).length !== 10) {
                                helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                              }
                              setIsInterNational(false);
                            } else {
                              setIsInterNational(true);
                            }
                            helperText.isPhoneNumber = "verifying...";
                            IsNumberBlackListed(phone);
                          }
                        }
                      } else {
                        helperText.isPhoneNumber = "Please Enter  Phone Number";
                        setShowOtp(false);
                      }
                      setPersonalDetail((pre) => {
                        pre.phoneNumber = phone;
                        return Object.assign({}, pre);
                      });
                    }}
                  /> */}
                   <PhoneInput
                    defaultCountry="IN"
                    value={personalDetail.phoneNumber}
                    disabled={showOtp || verifiedPhoneNumber || resendButton || (referrerDetails.relationship === "Self" && personalDetail.phoneNumber)}
                    placeholder="Enter phone number"
                    onChange={(phone) => {
                      if (phone !== undefined && phone.length >= 1) {
                        if (!isValidPhoneNumber(phone)) {
                          setVerifiedPhoneNumber(false);
                          setHelperText((prev) => ({
                            ...prev,
                            isPhoneNumber: "Please Enter valid Phone Number"
                          }));
                          setShowOtp(false);
                        } else {
                          // Set synchronously so the "Verify Otp" button (gated on
                          // helperText.isPhoneNumber === "") stays hidden for the
                          // debounced IsNumberBlackListed check below, instead of a
                          // window where it's clickable before that check resolves.
                          setHelperText((prev) => ({
                            ...prev,
                            isPhoneNumber: "verifying..."
                          }));
                          setVerifiedPhoneNumber(false);

                          if (phone.startsWith("+91")) {
                            if (phone.substring(3).length !== 10) {
                              setHelperText((prev) => ({
                                ...prev,
                                isPhoneNumber: "Please Enter valid Phone Number"
                              }));
                            }
                            setIsInterNational(false);
                          } else {
                            setIsInterNational(true);
                          }

                          IsNumberBlackListed(phone);
                        }
                      } else {
                        setHelperText((prev) => ({
                          ...prev,
                          isPhoneNumber: "Please Enter Phone Number"
                        }));
                        setShowOtp(false);
                      }

                      setPersonalDetail((prev) => ({
                        ...prev,
                        phoneNumber: phone
                      }));
                    }}
                  />
                  <p
                    style={{
                      color: "#d32f2f",
                      fontSize: "1.4rem",
                      lineHeight: "1.66",
                    }}
                  >
                    {helperText.isPhoneNumber}
                  </p>
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber === false &&
                    otptimer === false &&
                    showOtp === false &&
                    personalDetail.phoneNumber !== "" && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          smsApiCall();
                        }}
                      >
                        Verify Otp
                      </div>
                    )}
                  {verifiedPhoneNumber === false &&
                    showOtp === true &&
                    resendButton === true && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          setHelperText((pre) => {
                            pre.isPhoneNumber = "";
                            return { ...pre };
                          });
                          smsApiCall();
                        }}
                      >
                        Resend Otp
                      </div>
                    )}
                  {verifiedPhoneNumber === false &&
                    showOtp === true &&
                    resendButton === false && (
                      <div className={cssClasses.resendOtp}>
                        {" "}
                        Resend Otp in{" "}
                        {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
                        <CountdownTimer
                          startFrom={180}
                          onComplete={() => {
                            setResendButton(true);
                          }}
                          timeFormatter={(time) => {
                            return (
                              <span>
                                {`0${Math.floor(time / 60)}`.slice(-2)}:
                                {`0${time % 60}`.slice(-2)}
                              </span>
                            );
                          }}
                        />
                      </div>
                    )}
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber &&
                    otptimer === false && (
                      <div className={cssClasses.verifyOtp}>
                        <CheckCircleSharpIcon
                          style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                          color={"success"}
                        />
                      </div>
                    )}
                  {showOtp && (
                    <div className={cssClasses.otpContainer}>
                      <input
                        className={cssClasses.otpInput}
                        name="otp1"
                        id="opt-0"
                        type="text"
                        autoComplete="off"
                        value={state.otp1}
                        // onKeyPress={keyPressed}
                        onChange={(e) => optChange("otp1", e)}
                        tabIndex="0"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp2"
                        id="opt-1"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp2}
                        onChange={(e) => optChange("otp2", e)}
                        tabIndex="1"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp3"
                        id="opt-2"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp3}
                        onChange={(e) => optChange("otp3", e)}
                        tabIndex="2"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />
                      <input
                        name="otp4"
                        type="text"
                        id="opt-3"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp4}
                        onChange={(e) => optChange("otp4", e)}
                        tabIndex="3"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                      />

                      <div>
                        <Button
                          tabIndex={4}
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#155EEF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          btnName={"Submit OTP"}
                          clicked={submitOtp}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Type Of Lead <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={["Direct", "R&L"]}
                    selectedValue={personalDetail.typeOfLead}
                    onChangeSelect={(value) => {
                      setPersonalDetail((pre) => {
                        pre.typeOfLead = value;
                        return { ...pre };
                      });
                    }}
                    placeHolder={"Lead Type"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                   
                  />
                </div>
                {personalDetail.typeOfLead === "Direct" && (
                  <div>
                    <div className={cssClasses.blockLabel}>
                      Referral
                      {/* <span style={{ color: "red" }}> *</span> */}
                    </div>
                    {/* <DropDown
                      list={allUser.map((element, id) => {
                        return {
                          label: element.name,
                          value: element.name,
                        };
                      })}
                      selectedValue={personalDetail.leadReferrerName}
                      onChangeSelect={(value) => {
                        let selectedUserfromArray;
                        selectedUserfromArray = allUser.filter(
                          ({ name }) => value === name
                        );
                        console.log(selectedUserfromArray[0]);
                        // setSelectedUserData(selectedUserfromArray[0]);
                        setPersonalDetail((pre) => {
                          pre.leadReferrerName = value;
                          pre.leadSubType =
                            selectedUserfromArray[0]?.roleId?.roleId?.name;
                          return { ...pre };
                        });
                        setHelperText((preValue) => {
                          preValue.referal = "";
                          return { ...preValue };
                        });
                      }}
                      placeHolder={"Select Referral"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.referal}
                    /> */}
                    <ThemeProvider theme={AutoCompleTheme}>
                      <Autocomplete
                        id="free-solo-2-demo"
                        sx={{
                          fontSize: "1.6rem !important",
                          fontFamily: "Inter-Medium !important",
                          lineHeight: "2.4rem !important",
                          // borderColor: "none !important",

                          ".MuiOutlinedInput-root": {
                            background: "#F2F4F7",

                            borderRadius: "8px",
                            "&.Mui-focused": {
                              background: "#FFFFFF",
                              border: "1px solid #84CAFF !important",
                              boxShadow:
                                "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                            },
                          },
                          "& .MuiSvgIcon-root ": {
                            display: "none !important",
                          },
                        }}
                        value={personalDetail.leadReferrerName}
                        classes={{
                          option: classes.textStyle,
                        }}
                        options={allUser.map((option) => {
                          return { label: option.name, value: option.userId };
                        })}
                        PaperComponent={({ children }) => (
                          <Paper
                            style={{
                              fontFamily: "Inter-Medium",
                              fontSize: "1.6rem",
                            }}
                          >
                            {children}
                          </Paper>
                        )}
                        onChange={(event, newValue) => {
                          // console.log(newValue);
                          if (newValue !== null) {
                            let selectedUserfromArray;
                            selectedUserfromArray = allUser.filter(
                              ({ name }) => name === newValue.label
                            );
                            // console.log(selectedUserfromArray[0]);
                            // setSelectedUserData(selectedUserfromArray[0]);
                            setPersonalDetail((pre) => {
                              pre.leadReferrerName = newValue?.label;
                              pre.leadSubType =
                                selectedUserfromArray[0]?.roleId?.title;
                              return { ...pre };
                            });
                            // setHelperText((preValue) => ({
                            //   ...preValue,
                            //   referal: "",
                            // }));}else {

                            // setPersonalDetail((pre) => {
                            //   pre.leadReferrerName = "";
                            //   pre.leadSubType = "";
                            //   return { ...pre };
                            // });
                          }
                        }}
                        onInputChange={(event, newInputValue) => {
                          // getCPEDetails(newInputValue);
                          getSalesPersonDetails(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            classes={{ root: classes.customTextField }}
                            sx={{
                              fontSize: "1.6rem !important",
                              fontFamily: "Inter-Medium !important",
                              lineHeight: "2.4rem !important",
                              textTransform: "capitalize",
                              " .MuiFormHelperText-root ": {
                                fontSize: "1.4rem !important",
                                fontFamily: "Inter-Medium",
                                lineHeight: "2rem",
                                marginLeft: "0rem !important",
                              },
                            }}
                            placeholder="Referral Name *"
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                              style: { fontSize: "1.6rem" },
                            }}
                            // helperText={helperText.referal}
                            // error={helperText.referal !== ""}
                            onChange={(e, v) => {
                              // getCPEDetails(e.target.value);
                              getSalesPersonDetails(e.target.value);
                            }}
                          // helperText={helperText.salesPersonName}
                          // error={helperText.salesPersonName}
                          />
                        )}
                      />
                    </ThemeProvider>
                  </div>
                )}
                {personalDetail.typeOfLead === "R&L" && (
                  <>
                    <div>
                      <div className={cssClasses.blockLabel}>
                        Reference From <span style={{ color: "red" }}> *</span>
                      </div>
                      <DropDown
                        list={[
                          "Existing customer - Pre-Agreement",
                          "Existing Customer - Post-Agreement",
                          // Temporarily hidden - uncomment to restore
                          // "VJ Employee",
                          // "Vendor",
                        ]}
                        selectedValue={String(referrerDetails.type) || ''}
                        onChangeSelect={(value) => {
                          setReferrerDetails((pre) => {
                            pre.type = value;
                            pre.name= "";
                            pre.contactNumber ="";
                            pre.projectName ="";
                            pre.projectId ="";
                            pre.wingName ="";
                            pre.wingId ="";
                            pre.unitNo ="";
                            pre.unitId="";
                            pre.remarks ="";
                            pre.relationship="";
                            return { ...pre };
                          });
                          if (value !== "") {
                            setReferrerDetailsHelperText((preValue) => ({
                              ...preValue,
                              type: "",
                            }));
                          }
                          if (value === "Existing Customer - Post-Agreement") {
                            getProjectDetails();
                          }else if (value === "Existing customer - Pre-Agreement") {
                            getProjectDetailsPreExisting();
                          }
                          else{
                            setReferrerDetails((pre) => {
                              pre.name = "";
                              pre.contactNumber="";
                              pre.unitNo="";
                              return { ...pre };
                            });
                          }
                        }}
                        placeHolder={"Select From"}
                        //style.color is placeHolder's color
                        style={{
                          background: "#F2F4F7",
                          color: "rgb(102, 112, 133)",
                        }}
                        helperText={referrerDetailsHelperText.type}
                      />
                    </div>
                    {referrerDetails.type === "Existing Customer - Post-Agreement" && (
                      <>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Project Name <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={projectsList.map((element, id) => {
                              return {
                                label: element.project,
                                value: element.project,
                              };
                            })}
                            selectedValue={referrerDetails.projectName}
                            onChangeSelect={(value) => {
                              let selectedProject;
                              selectedProject = projectsList.filter(
                                ({ project }) => value === project
                              );
                              // getAllWings(selectedProject[0]);
                              setWingsList(selectedProject[0].wings);
                              // console.log({ selectedProject });
                              setReferrerDetails((pre) => {
                                pre.projectName = value;
                                pre.projectId = selectedProject[0].BUId;
                                pre.wingName = "";
                                pre.wingId = "";
                                // pre.unitNo ="";
                                // pre.unitId="";
                                // pre.name= "";
                                return { ...pre };
                              });
                               if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.projectId = "";
                                  return { ...preValue };
                                });
                              }
                            }}
                            placeHolder={"Project Name"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                               
                             
                            helperText={referrerDetailsHelperText.projectId}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Select Wing <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={sortBy(wingsList, "wing").map(
                              (element, id) => {
                                return {
                                  label: element.wing,
                                  value: element.wing,
                                };
                              }
                            )}
                            selectedValue={referrerDetails.wingName}
                            onChangeSelect={(value) => {
                              let selectedProject;
                              selectedProject = wingsList.filter(
                                ({ wing }) => value === wing
                              );
                              // console.log({ selectedProject });
                              setUnitsList(selectedProject[0].units)
                              setReferrerDetails((pre) => {
                                pre.wingName = value;
                                pre.wingId = value;
                                pre.unitNo = "";
                                pre.unitId="";
                                return { ...pre };
                              });
                              if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.wingId = "";
                                  return { ...preValue };
                                });
                              }
                            }}
                            disable={referrerDetails.projectName === ""}
                            placeHolder={"Select Wing"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={referrerDetailsHelperText.wingId}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Select Unit Number <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={unitsList.map(
                              (element, id) => {
                                return {
                                  label: element,
                                  value: element,
                                };
                              }
                            )}
                            selectedValue={referrerDetails.unitNo}
                            onChangeSelect={(value) => {
                              setReferrerDetails((pre) => {
                                pre.unitNo = value;
                                return { ...pre };
                              });
                              if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.unitId = "";
                                  return { ...preValue };
                                });
                              }
                              getCustomerData();

                            }}
                            placeholder="Enter Unit Number"
                            disable={referrerDetails.wingName === ""}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={referrerDetailsHelperText.unitId}
                          />
                        </div>
                      </>
                    )}
                     {referrerDetails.type === "Existing customer - Pre-Agreement" && (
                      <>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Project Name
                             <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={projectsListPre
                              // .filter((element) => element.isPublished === true)
                              .map((element, id) => {
                              return {
                                label: element.projectName,
                                value: element.projectId,
                              };
                            })}
                            selectedValue={referrerDetails.projectId}
                            onChangeSelect={(value) => {
                              let selectedProject;
                              selectedProject = projectsListPre.filter(
                                ( ele ) => value === ele.projectId
                              );
                           
                             
                              getWingsDetailsPreExisting(value)
                              
                              if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.projectId = "";
                                  return { ...preValue };
                                });
                              }
                              setReferrerDetails((pre) => {
                                pre.projectName =selectedProject[0].projectName;
                                pre.projectId = value;
                                pre.wingName = "";
                                pre.wingId = "";
                                // pre.unitNo ="";
                                // pre.unitId="";
                                // pre.contactNumber ="";
                                return { ...pre };
                              });
                            }}
                            placeHolder={"Project Name"}
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                           helperText={referrerDetailsHelperText.projectId}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Select Wing
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={allWings.length>0?sortBy(allWings, "wing").map(
                              (element, id) => {
                                return {
                                  label: element.wingName,
                                  value: element.wingId,
                                };
                              }
                            ):[]}
                            selectedValue={referrerDetails.wingId}
                            onChangeSelect={(value) => {
                              let selectedProjectWing;
                              selectedProjectWing = allWings.filter(
                                (wing) => value === wing.wingId
                              );
                              if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.wingId = "";
                                  return { ...preValue };
                                });
                              }
                              getAllUnitsByProjectIdWingsId(referrerDetails.projectId,value)
                                .then((response) => {
                                 const selectUnits= response?.data.filter((element) => element.unitId.inventoryStatusId.status === "Payment Pending" ||  element.unitId.inventoryStatusId.status === "Kyc Pending"||element.unitId.inventoryStatusId.status === "Kyc Done")
                                 setUnitsListPre(selectUnits);
                                })
                                .catch((err) => {
                                  console.error('getAllUnitsByProjectId', err);
                                });
                              setReferrerDetails((pre) => {
                                pre.wingName = selectedProjectWing[0].wingName;
                                pre.wingId = value;
                                pre.unitNo = "";
                                pre.name= "";
                                pre.contactNumber ="";
                                return { ...pre };
                              });
                            }}
                            disable={referrerDetails.projectName === ""}
                            placeHolder={"Select Wing"}
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={referrerDetailsHelperText.wingId}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Select Unit Number
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={unitsListPre.length>0? unitsListPre
                              ?.sort((a, b) => {
                                return a.unitId.unitNo - b.unitId.unitNo;
                              })
                              ?.map(
                              (element, id) => {
                                return {
                                  label: element.unitId.unitNo,
                                  value: element.unitId.unitId,
                                };
                              }
                            ) :[]}
                            selectedValue={referrerDetails.unitId }
                            onChangeSelect={(value) => {
                             const  selectedProjectFloor = unitsListPre.filter(
                                (floor) => value === floor.unitId.unitId
                              );
                              if(value!==""){
                                setReferrerDetailsHelperText((preValue) => {
                                  preValue.unitId = "";
                                  return { ...preValue };
                                });
                              }
                              setReferrerDetails((pre) => {
                                pre.unitNo = selectedProjectFloor[0].unitId.unitNo;
                                pre.unitId = value;
                                pre.name= "";
                                pre.contactNumber ="";
                                return { ...pre };
                              });
                                
                              getRerreralDetailsPre(value);
                            
                            }}
                            placeholder="Enter Unit Number"
                            disable={referrerDetails.wingName === "" || unitsListPre<=0}
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={referrerDetailsHelperText.unitId}
                          />
                          
                          {!referrerDetailsHelperText.unitId && referrerDetails.wingName && unitsListPre.length === 0 && (
                            <p  style={{
                              color: "#d32f2f",
                               fontSize: "1.4rem",
                               lineHeight: "1.66",
                             }}>
                              No units Available
                            </p>
                          )}
                        </div>
                      </>
                    )}
                    <div>
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={referrerDetails.type ===  "Vendor" ||  referrerDetails.type ===   "Channel Partner" ?"":referrerDetails?.name}
                        handleChange={(value) => {
                          setReferrerDetails((pre) => {
                            pre.name = value;
                            return { ...pre };
                          });


                        }}
                        label={"Referrer Name"}
                        mandatory={false}
                        disabled={referrerDetails.type === "VJ Employee" || referrerDetails.type === "PN-PKC" ? false : true }
                        placeholder="Enter Referrer Name"
                        inputType="label"
                      />
                    </div>
                    <div>
                      <div className={cssClasses.blockLabel}>
                        Relationship
                      {(referrerDetails.type === "Existing customer - Pre-Agreement" || referrerDetails.type === "Existing Customer - Post-Agreement") &&  <span style={{ color: "red" }}> *</span>} 
                      </div>
                      <DropDown
                        list={[
                          'Son',
                          'Daughter',
                          'Brother',
                          'Sister',
                          'Mother',
                          'Father',
                          'Grandmother',
                          'Grandfather',
                          'Uncle',
                          'Aunt',
                          'Cousin',
                          'Nephew',
                          'Niece',
                          'Brother-in-law',
                          'Sister-in-law',
                          'Father-in-law',
                          'Mother-in-law',
                          'Son-in-law',
                          'Daughter-in-law',
                          'Friend',
                          'Colleague',
                          'Neighbor',
                          'Mentor',
                          'Mentee',
                          'Spouse',
                          'Partner',
                          'Self',
                          'Other',
                        ]}
                        selectedValue={referrerDetails.relationship}
                        onChangeSelect={(value) => {
                          setReferrerDetails((pre) => {
                            pre.relationship = value;
                            return { ...pre };
                          });
                          if(value!==""){
                            setReferrerDetailsHelperText((preValue) => {
                              preValue.relationship = "";
                              return { ...preValue };
                            });
                          }

                        }}
                        placeHolder={"Select"}
                        style={{
                          background: "#F2F4F7",
                          color: "rgb(102, 112, 133)",
                        }}
                        helperText={referrerDetailsHelperText.relationship}
                      />
                    </div>
                    <div style={{ position: "relative" }}>
                      <div className={cssClasses.blockLabel}>
                        Referrer Mobile Number{" "} 
                        {referrerDetails.type === "Existing customer - Pre-Agreement" &&<span style={{ color: "red" }}> *</span>}
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </div>
                      <PhoneInput
                        defaultCountry="IN"
                        value={(referrerDetails.type ===  "Vendor" || referrerDetails.type === "Channel Partner") ? null :referrerDetails.contactNumber}
                        onChange={(phone) => {
                          if (phone !== undefined) {
                            if (phone.length >= 1) {
                              if (isValidPhoneNumber(phone) === false) {
                                referrerDetailsHelperText.contactNumber = `Please Enter valid Phone Number`;
                              } else {
                                referrerDetailsHelperText.contactNumber = "";
                                if (phone.substring(0, 3) === "+91") {
                                  if (phone.substring(4, 13).length !== 10) {
                                    referrerDetailsHelperText.contactNumber = `Please Enter valid Phone Number`;
                                  }
                                  setIsInterNational(false);
                                } else {
                                  setIsInterNational(true);
                                }
                                referrerDetailsHelperText.contactNumber = "";
                                IsNumberBlackListed(phone);
                              }
                            }
                          } else {
                            referrerDetailsHelperText.contactNumber = "Please Enter  Phone Number";
                          }
                          setReferrerDetails((pre) => {
                            pre.contactNumber = phone;
                            return Object.assign({}, pre);
                          }); 
                          if(phone){
                            setReferrerDetailsHelperText((preValue) => {
                              preValue.contactNumber ="";
                              return { ...preValue };
                            });
                          }
                         
                        }}
                        placeholder="Enter referrer mobile number"
                        disabled={referrerDetails.type === "VJ Employee" || referrerDetails.type === "PN-PKC" ? false : true }
                      />
                      <p
                        style={{
                         color: "#d32f2f",
                          fontSize: "1.4rem",
                          lineHeight: "1.66",
                        }}
                      >
                        {referrerDetails.type ===  "Vendor" ||  referrerDetails.type ===   "Channel Partner" ?"":referrerDetailsHelperText.contactNumber}
                      </p>
                    </div>


                    <div>
                      <div className={cssClasses.blockLabel}>
                        Remarks
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </div>
                      <TextField
                        maxRows={4}
                        value={referrerDetails.remarks}
                        onChange={(e) => {
                          e.target.value = e.target.value.trimStart();
                          if (e.target.value.length <= 200) {
                            setReferrerDetails((pre) => {
                              pre.remarks = e.target.value;
                              return { ...pre };
                            });
                          }
                        }}
                        placeholder={"Remarks"}
                        // helperText={helperText}
                        // error={helperText !== ""}
                        className={classes.TextFieldStyle}
                        InputProps={{
                          className: classes.inputStyle,
                        }}
                        inputProps={{ min: 0 }}
                        FormHelperTextProps={{ className: classes.helperText }}
                        multiline
                      />
                    </div>
                  </>
                )}
                <div>
                  <div className={cssClasses.blockLabel}>
                    Gender <span style={{ color: "red" }}> *</span>
                  </div>
                  <FormControl disabled={personalDetail.disabledGender}>
                    {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: "#155EEF !important",
                          fontSize: "2rem !important",
                        },
                      }}
                      value={personalDetail.gender}
                      onChange={(e) => {
                        // console.log(e.target.value);
                        setPersonalDetail((pre) => {
                          pre.gender = e.target.value;
                          return Object.assign({}, pre);
                        });
                      }}
                    >
                      <FormControlLabel
                        className={classes.radioLabel}
                        value={"Male"}
                        control={<Radio />}
                        label={<div className={classes.radioLabel}>Male</div>}
                      />
                      <FormControlLabel
                        className={classes.radioLabel}
                        value={"Female"}
                        control={<Radio />}
                        label={<div className={classes.radioLabel}>Female</div>}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            <div>
                {/* {isCPLead && (
                  <div style={{ color: "red", fontSize: "1.5rem", backgroundColor: "#f8d7da", width:"100%", justifyContent: "center", display: "flex", padding: "1rem", borderRadius: "0.5rem" }}>Warning: This lead is tagged under a CP. You cannot add a referral before the agreement is done.</div>
                )} */}
                {(
                  personalButtonNext ? (
                    <Button
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                      }}
                      btnName={"Proceed"}
                      clicked={validatePersonalDetails}
                      btnIcon={<RightArrow />}
                      iconPosition={"right"}
                    />
                  ) : (
                    <Button
                      style={{
                        color: "#155EEF",
                        border: "1px solid #155EEF",
                        backgroundColor: "#ffffff",
                      }}
                      btnName={"Proceed"}
                      clicked={validatePersonalDetails}
                      btnIcon={<RightArrow />}
                      iconPosition={"right"}
                    />
                  )
                )}
                {/* {
                  personalButtonNext && ( <Button
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                      }}
                      btnName={"Proceed"}
                      clicked={validatePersonalDetails}
                      btnIcon={<RightArrow />}
                      iconPosition={"right"}
                    />)
                } */}
              </div>
            </div>
          )}
          {activeStep === 2 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.addHeightToMiddleContent}>
                <div className={cssClasses.detailText}>Personal Details</div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Nationality <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={nationality.map((element, id) => {
                      return {
                        label: element.nationality,
                        value: element.nationalityId,
                      };
                    })}
                    selectedValue={generalDetail.nationality}
                    onChangeSelect={(value) => {
                      setGeneralDetail((pre) => {
                        pre.nationality = value;
                        return { ...pre };
                      });
                      if (generalDetail.nationality !== "") {
                        helperText.nationality = "";
                      } else {
                        helperText.nationality = "Please Select Nationality";
                      }
                    }}
                    placeHolder={"Nationality"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.nationality}
                    disable={generalDetail.disabledNationality}
                  />
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Native <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={native.map((element, id) => {
                      return {
                        label: element.native,
                        value: element.nativeId,
                      };
                    })}
                    selectedValue={generalDetail.native}
                    onChangeSelect={(value) => {
                      setGeneralDetail((pre) => {
                        pre.native = value;
                        return { ...pre };
                      });
                      if (generalDetail.native !== "") {
                        helperText.native = "";
                      } else {
                        helperText.nationality = "Please Select Native";
                      }
                    }}
                    placeHolder={"Native"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.native}
                    disable={generalDetail.disabledNative}
                  />
                  {/* If you use this you need to send native.nativeId while inserting */}
                  {/* <ThemeProvider theme={AutoCompleTheme}>
                  <Autocomplete
                    id="free-solo-2-demo"
                    sx={{
                      fontSize: "1.6rem !important",
                      fontFamily: "Inter-Medium !important",
                      lineHeight: "2.4rem !important",
                      // borderColor: "none !important",
                      ".MuiOutlinedInput-root": {
                        background: "#F2F4F7",
                        borderRadius: "8px",
                        "&.Mui-focused": {
                          background: "#FFFFFF",
                          border: "1px solid #84CAFF !important",
                          boxShadow:
                            "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                        },
                      },
                      "& .MuiSvgIcon-root ": {
                        display: "none !important",
                      },
                    }}
                    value={generalDetail.native}
                    classes={{
                      option: classes.textStyle,
                    }}
                    options={native.map((option) => {
                      return { label: option.native, value: option.nativeId };
                    })}
                    PaperComponent={({ children }) => (
                      <Paper
                        style={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.6rem",
                        }}
                      >
                        {children}
                      </Paper>
                    )}
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      setGeneralDetail((pre) => {
                        pre.native = newValue;
                        return { ...pre };
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      console.log({newInputValue})
                      getAllNatives(newInputValue);
                      if(newInputValue===''){
                        setHelperText((pre) => {
                          pre.native = "Please Select Native";
                          return { ...pre };
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        classes={{ root: classes.customTextField }}
                        sx={{
                          fontSize: "1.6rem !important",
                          fontFamily: "Inter-Medium !important",
                          lineHeight: "2.4rem !important",
                          textTransform: "capitalize",
                          " .MuiFormHelperText-root ": {
                            fontSize: "1.4rem !important",
                            fontFamily: "Inter-Medium",
                            lineHeight: "2rem",
                            marginLeft: "0rem !important",
                          },
                        }}
                        placeholder="Native *"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                          style: { fontSize: "1.6rem" },
                        }}
                        onChange={(e, v) => {
                          getAllNatives(e.target.value);
                        }}
                        helperText={helperText.native}
                        error={helperText.native}
                      />
                    )}
                  />
                </ThemeProvider> */}
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    WorksIn <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={wroksIn.map((element, id) => {
                      return {
                        label: element.profession,
                        value: element.professionId,
                      };
                    })}
                    selectedValue={generalDetail.worksIn}
                    onChangeSelect={(value) => {
                      // console.log(value);
                      // console.log(generalDetail.worksIn);
                      // console.log(value);
                      setGeneralDetail((pre) => {
                        pre.worksIn = value;
                        return { ...pre };
                      });
                      if (generalDetail.worksIn !== "") {
                        helperText.worksIn = "";
                      } else {
                        helperText.worksIn = "Please Select WorksIn";
                      }
                    }}
                    placeHolder={"Works In"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.worksIn}
                    disable={generalDetail.disabledWorksIn}
                  />
                </div>
              </div>
              <div>
                {generalButtonNext ? (
                  <Button
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    btnName={"Proceed"}
                    
                    clicked={validateGeneralDetails}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                ) : (
                  <Button
                    style={{
                      color: "#155EEF",
                      border: "1px solid #155EEF",
                      backgroundColor: "#ffffff",
                    }}
                    clicked={validateGeneralDetails}
                    btnName={"Proceed"}
                    
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                )}
              </div>
            </div>
          )}
          {activeStep === 3 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>Project Details</div>

              <div className={cssClasses.wrapperProjectDeatils}>
                {projectFieldArray.map((each, index) => (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "2rem",
                    }}
                  >
                    {index >= 1 && (
                      <span
                         key={index+1}
                        className={classes.closeIcon}
                        tabIndex={0}
                        onClick={() => {
                          projectFieldArray.forEach((each) => {
                            if (projectFieldArray[index].isPrimary) {
                              projectFieldArray[index - 1].isPrimary = true;
                            }
                          });
                          let arr = projectFieldArray;
                          arr.splice(index, 1);
                          setProjectFieldArray([...arr]);
                          let helperTextArr = projectFieldHelperText;
                          projectFieldHelperText.splice(index, 1);
                          setProjectFieldHelperText([...helperTextArr]);
                        }}
                      >
                        <Close width={"1.2rem"} height={"1.2rem"} />
                      </span>
                    )}

                    {modalType === "SustenanceAddLead" && (
                      <Fragment>
                        <div>
                          <CustomInput
                            value={projectName}
                            disabled={true}
                            label={"Project"}
                            mandatory={true}
                          />
                        </div>

                        <div>
                          <div className={cssClasses.blockLabel}>
                            Flat/Unit Type
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={InventoryType.map((m) => m.inventoryTypeId)
                              .reduce((arr, ele) => {
                                if (
                                  !arr.some(
                                    (s) =>
                                      s.inventoryTypeId === ele.inventoryTypeId
                                  )
                                ) {
                                  arr.push(ele);
                                }
                                return arr;
                              }, [])
                              .map((m) => ({ label: m.type, value: m.type }))}
                            selectedValue={each.flatUnitType}
                            onChangeSelect={(value) => {
                              setProjectFieldArray((pre) => {
                                // console.log(pre);
                                pre[index].flatUnitType = value;
                                return [...pre];
                              });
                              setProjectFieldHelperText((pre) => {
                                pre[index].flatUnitType = "";
                                return [...pre];
                              });
                            }}
                            placeHolder={"Flat/Unit Type"}
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={
                              projectFieldHelperText[index]?.flatUnitType ?? ""
                            }
                            disable={each.alreadyAdded}
                          />
                        </div>
                      </Fragment>
                    )}
                    {modalType !== "SustenanceAddLead" && (
                      <Fragment>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Project <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={projectNameList.map((element, id) => {
                              return {
                                label: element.projectName,
                                value: element.projectName,
                              };
                            })}
                            selectedValue={each.selectedProject}
                            onChangeSelect={(value) => {
                              let selectedProject;
                              selectedProject = projectNameList.filter(
                                ({ projectName }) => value === projectName
                              );
                              setProjectFieldArray((pre) => {
                                // console.log(pre[index]);
                                pre[index].selectedProject = value;
                                pre[index].flatUnitType = "";
                                pre[index].selectedProjectData = selectedProject[0];
                                return [...pre];
                              });
                              funGetProjectUnitType(
                                selectedProject[0].projectId,
                                index
                              );

                              setProjectFieldHelperText((pre) => {
                                pre[index].selectedProject = "";
                                return [...pre];
                              });
                              // each.selectedProject=value;
                            }}
                            placeHolder={"Select Project"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={
                              projectFieldHelperText[index]?.selectedProject ??
                              ""
                            }
                            disable={each.alreadyAdded}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Flat/Unit Type
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={uniq(each.availableUnitType)}
                            selectedValue={each.flatUnitType}
                            onChangeSelect={(value) => {
                              setProjectFieldArray((pre) => {
                                // console.log(pre);
                                pre[index].flatUnitType = value;
                                return [...pre];
                              });
                              setProjectFieldHelperText((pre) => {
                                pre[index].flatUnitType = "";
                                return [...pre];
                              });
                              // each.selectedProject=value;
                            }}
                            placeHolder={"Flat/Unit Type"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={
                              projectFieldHelperText[index]?.flatUnitType ?? ""
                            }
                            disable={each.alreadyAdded}
                          />
                        </div>
                      </Fragment>
                    )}

                    <div>
                      <div className={cssClasses.blockLabel}>
                        Site Visit Date
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </div>
                      <DateComponent
                        value={each.SitePrefernces}
                        onChangeDate={(value) => {
                          // console.log(each);
                          setProjectFieldArray((pre) => {
                            // console.log(pre);
                            pre[index].SitePrefernces = value;
                            return [...pre];
                          });
                          // setProjectFieldHelperText((pre) => {
                          //   console.log(pre);
                          //   pre[index].SitePrefernces = "";
                          //   return [...pre];
                          // });
                        }}
                        helperText={
                          projectFieldHelperText[index]?.SitePrefernces ?? ""
                        }
                        disable={each.alreadyAdded}
                      />
                    </div>
                    <div>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={projectFieldArray[index].isPrimary}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: "#155EEF !important",
                              fontSize: "2rem !important",
                            },
                          }}
                          onChange={(e) => {
                            projectFieldArray.forEach((el, arrayIndex) => {
                              setProjectFieldArray((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  isPrimary: false,
                                }));
                                pre[index].isPrimary = true;
                                return [...pre];
                              });
                            });
                            // console.log(projectFieldArray);
                          }}
                        >
                          <FormControlLabel
                            className={classes.radioLabel}
                            value={true}
                            control={<Radio />}
                            label={
                              <div className={classes.radioLabel}>
                                Mark as primary
                              </div>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div>
                      {projectFieldArray.length === index + 1 && (
                        // projectNameList.length >= projectFieldArray.length &&
                        <div className={cssClasses.wrapperAddPrefernce}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              columnGap: "1rem",
                            }}
                          >
                            <img src={AddIcon} alt={"addIcon"}></img>
                            <span
                              className={cssClasses.addPrefernceText}
                              onClick={() => {
                                let value = false;
                                value = projectFieldArray.every((el) => {
                                  if (
                                    // el.SitePrefernces !== "" &&
                                    el.flatUnitType !== "" &&
                                    el.selectedProject !== ""
                                  ) {
                                    return true;
                                  } else {
                                    validationProjectFields();
                                    return false;
                                  }
                                });
                                // console.log(value);
                                if (value === true) {
                                  let tempArray = projectFieldArray;
                                  let helperText = projectFieldHelperText;
                                  tempArray.push({
                                    selectedProject: "",
                                    flatUnitType: "",
                                    availableUnitType: [],
                                    SitePrefernces: null,
                                    isPrimary: false,
                                    alreadyAdded: false,
                                    selectedProjectData: null
                                  });
                                  helperText.push({
                                    selectedProject: "",
                                    flatUnitType: "",
                                    SitePrefernces: "",
                                  });
                                  setProjectFieldArray([...tempArray]);
                                  setProjectFieldHelperText([...helperText]);
                                }
                              }}
                            >
                              Add another Preference
                            </span>
                          </div>
                          {/* {index >= 1 && (
                            <span
                              className={cssClasses.addPrefernceText}
                              onClick={() => {
                                setProjectFieldArray((pre) => {
                                  pre.pop();
                                  return [...pre];
                                });
                              }}
                            >
                              Delete Preference
                            </span>
                          )} */}
                        </div>
                      )}

                      <Divider
                        sx={{
                          border: " 1px solid #98A2B3",
                          /* Shadow/xs */
                          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        }}
                      ></Divider>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                {projectButtonNext ? (
                  <Button
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    btnName={"Proceed"}
                    
                    clicked={validateProjectFields}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                ) : (
                  <Button
                    style={{
                      color: "#155EEF",
                      border: "1px solid #155EEF",
                      backgroundColor: "#ffffff",
                    }}
                    clicked={validateProjectFields}
                    btnName={"Proceed"}
                   
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                )}
              </div>
            </div>
          )}
          {activeStep === 4 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>KYC</div>
              <div>
                <CustomInput
                  label={"PAN Number"}
                  value={panNumber}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    newValue = newValue.toUpperCase();
                    var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                    if (newValue === "") {
                      helperText.isPanValid = false;
                      setPanName("");
                      helperText.panNumber = "";
                    } else if (!regex.test(newValue)) {
                      helperText.isPanValid = false;
                      setPanName("");
                      helperText.panNumber = "Please enter Valid PAN number.";
                    } else {
                      helperText.panNumber = "";

                      if (newValue.length === 10) {
                        // if(_isValid.flag) {
                        setIsLoadingPan(true);
                        Network.getStatus().then((status) => {
                          if (status.connected) {
                            PAN_CardCheck(newValue.toUpperCase());
                          } else {
                            offlineToast();
                          }
                        });
                      }
                    }
                    if (newValue.length <= 10) {
                      setPanNumber(newValue);
                    }
                  }}
                  placeholder="Enter PAN Number (Optional)"
                  inputType="label"
                  helperText={helperText.panNumber}
                  isLoading={isLoadingPan}
                  greenTick={helperText.isPanValid}
                />
              </div>
              {panName && (
                <div className={cssClasses.wrapperPanName}>{panName}</div>
              )}
              <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#155EEF",
                }}
                clicked={submit}
                btnName={"Submit"}
              />
            </div>
          )}
          <ConfirmationAlert
            open={openConfirmation}
            close={() => {
              setOpenConfirmation(false);
            }}
            // icon={<GreenChecked width={"4.8rem"} height={"4.8rem"} />}
            title={"Info !"}
            subTitle={
              `Lead name is different from that of PAN number. Do you wish to create lead with name ${panName}?`
            }
            confirm={(value) => {
              if (value === "confirmed") {
                setPersonalDetail((pre) => {
                  pre.name = panName;
                  return { ...pre };
                });
              }
              setOpenConfirmation(false);
              // console.log(value);
            }}
            buttonTitle={"No"}
            returnRespButton={"Yes"}
          />
        </div>
      </Box>
    </Modal>
  );
}